'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=require('./createColorPalette'),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var orange={1:'#fff3e3',2:'#ffd69b',3:'#ffb55f',4:'#ff943b',5:'#e65f14',6:'#d04a00',7:'#b54102',8:'#983702',9:'#7a2d00',10:'#541f00',inflection:6};exports.default=(0,_createColorPalette2.default)(orange,'orange');


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/colors/orange.js
 **/